import React from 'react';
import Resizer from "react-image-file-resizer";

const ImageResizer = (file, maxWidth, maxHeight) => {
    
    const resizeImage = async () => {
        console.log("checking file ...",file);
        return new Promise((resolve, reject) => {
          Resizer.imageFileResizer(
            file,
            maxWidth,
            maxHeight,
            file.type === 'image/png' ? 'PNG' : 'JPEG',
            100,
            0,
            (uri) => {
              resolve(uri);
            },
            'blob',
            0,
            0,
            (error) => {
              reject(error);
            }
          );
        });
      };
    
      return {
        resizeImage,
      };
};

export default ImageResizer;

